<div class="inbox-personal home-section">
    <div class="title-section">
        <div class="inbox-marker"></div>
        <div class="div-label">
            <mat-label class="label-title">Mi Bandeja</mat-label> 
            <div *ngIf="canPermissionTeam" >
                <a class="change-inbox" (click)="showInboxTeam()">
                    Cambiar a Bandejas de mi Equipo
                </a>
            </div>
        </div> 
    </div>
    <div class = "search-section">
        <mat-form-field class="search-well-card dense-3">
            <mat-label class = "label-well">Buscá un pozo</mat-label>
            <input type="text" value={{textSearch}} aria-label="Well" 
            matInput #searchText (keyup.enter)="getHandoversHomeInboxPersonalWithFilter(searchText.value)">
            <span matSuffix class="cursor-pointer" (click)="getHandoversHomeInboxPersonalWithFilter(searchText.value)">
              <mat-icon class="material-icons-outlined" aria-hidden="false" aria-label="Account">search</mat-icon>
            </span>
        </mat-form-field> 
    </div>
    <div class="content-section">
        <div class="handovers" *ngIf="totalHandoversInboxPersonal != 0">
            <app-handover-card *ngFor="let handover of handoversInboxPersonal" [handover]="handover"
                (reload)="eventReload($event)" [destinationLabel]="destinationLabel">
            </app-handover-card>
        </div>
        <div class="empty-content" *ngIf="totalHandoversInboxPersonal == 0">
            <div *ngIf="this.textSearch == ''">
                <p class="personal-empty">No hay Handovers aún</p>
                <p class="personal-empty-text">Cuando tomes un Handover de la <br> Bandeja General, podrás visualizarlo acá</p>
            </div>
            <div *ngIf="this.textSearch != ''">
                <p class="personal-empty">No hay handovers para el filtro aplicado</p>
            </div>
        </div>
    </div>
</div>